import { useForm } from 'react-hook-form';
import { useState } from 'react';

import { PATTERNS_CONSTANTS } from '@ui/constants';

export interface ForgotForm {
  email: string;
}

export function useForgotPasswordState(
  onForgot: (form: ForgotForm, errorCallback: (e: string) => void) => void,
) {
  const { control, handleSubmit, setError } = useForm<ForgotForm>({
    defaultValues: {
      email: '',
    },
    mode: 'all',
  });

  const [isLoading, setLoading] = useState(false);

  function handleError(message: string) {
    setError('email', { message });
  }

  async function handleForgot(form: ForgotForm) {
    setLoading(true);
    try {
      await onForgot(form, handleError);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  }

  return {
    isLoading,
    email: {
      name: 'email' as 'email',
      control,
      rules: {
        required: 'Please enter your email',
        pattern: {
          value: PATTERNS_CONSTANTS.email,
          message: 'Please enter valid email address',
        },
      },
    },
    onSubmit: handleSubmit(handleForgot),
  };
}
